<template>
  <div>
    <div v-if="hasQuery">
      <div class="errorWrap">
        <div class="errorImg"></div>
        <p class="errorText">
          죄송합니다<br>
          일시적 오류로<br>
          <span>주문이 취소되었습니다.</span>
        </p>
        <p class="errorMsg">({{ query.resultCode + ' ' + query.resultMessage }})</p>
        <p class="errorInfo">다시 주문 진행 부탁드립니다</p>
        <!-- <ul class="paymentBox">
          <li>
            <div>취소금액</div>
            <div>45,000</div>
          </li>
          <li>
            <div>취소일시</div>
            <div>2020.01.01 12:12:12</div>
          </li>
          <li>
            <div>결제수단</div>
            <div>신한카드</div>
          </li>
          <li>
            <div>할부</div>
            <div>3개월</div>
          </li>
        </ul> -->
      </div>
      <div class="errorBottomBtn" @click="reOrder()">다시 주문하기</div>
    </div>
    <div v-else>
      <div class="errorWrap">
        <div class="errorImg"></div>
        <p class="errorText">
          서비스 이용에 불편을 드려 죄송합니다.<br>
          <span>잠시 후 다시 시도해주세요.</span>
        </p>
      </div>
      <div class="errorBottomBtn" @click="appMoveMain()">확인</div>
    </div>
  </div>
</template>
<script>
import service from '@/backend/modnpay_app_api'
export default {
  data () {
    return {
      query: this.$route.query,
      url: ''
    }
  },
  mounted () {
    this.storeIntroUrl()
  },
  computed: {
    hasQuery () {
      return !!Object.keys(this.query).length
    }
  },
  methods: {
    async storeIntroUrl () {
      const req = {
        urlCode: this.$store.getters.storeCode,
        introUrlType: this.$store.getters.qrType
      }
      const { data } = await service.storeIntroUrl(req)
      // const { data } = await service.orderStoreIntroUrl(req)

      this.url = data.introUrl
    },
    reOrder () {
      sessionStorage.removeItem('tradition')
      sessionStorage.removeItem('categoryCode')
      sessionStorage.removeItem('addressByLotNum')
      sessionStorage.removeItem('time')
      // const url = sessionStorage.getItem('url')
      window.location.replace(this.url)
    }
  }

}
</script>

<style scoped>
</style>
